<template>
  <tree-node :items="items" :active="active" @select="select" />
</template>
<script>
import TreeNode from './TreeNode'

export default {
  components: {
    TreeNode,
  },
  props: {
    items: Array,
  },
  data() {
    return {
      active: {},
    }
  },
  methods: {
    select(item) {
      this.active = item
      this.$emit('select', item)
    },
  },
}
</script>
